import { useRef } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppButton";
import { useWhatsAppLink, useViewportOffsetVar } from "@/lib/whatsapp";

export function StickyMobileBar() {
  const wa = useWhatsAppLink("mobile_bar");
  const ref = useRef(null);
  useViewportOffsetVar(ref, "--mobile-bar-h");
  return (
    <div
      ref={ref}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="sticky-mobile-bar"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-wafa-deep/10 bg-white/95 backdrop-blur-md md:hidden"
    >
      <div className="grid grid-cols-3 gap-1 px-2 py-2">
        <a
          href={wa?.href || "#"}
          onClick={wa?.onClick}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex flex-col items-center justify-center rounded-md py-2 text-xs font-medium text-wafa-primary"
        >
          <WhatsAppIcon size={16} className="mb-0.5" />
          <span>WhatsApp</span>
        </a>
        <a
          href="mailto:support@wafa.om"
          data-testid="mobile-bar-email"
          className="flex flex-col items-center justify-center rounded-md py-2 text-xs font-medium text-wafa-deep"
        >
          <Mail className="mb-0.5 h-4 w-4" />
          <span>Email</span>
        </a>
        <Link
          to="/contact"
          data-testid="mobile-bar-quote"
          className="flex flex-col items-center justify-center rounded-md bg-wafa-primary py-2 text-xs font-semibold text-white"
        >
          <ArrowRight className="mb-0.5 h-4 w-4" />
          <span>Get a Quote</span>
        </Link>
      </div>
    </div>
  );
}
